"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _chunk7VBK3YDPjs = require("./chunk-7VBK3YDP.js");
var _chunkL6B4ALZ3js = require("./chunk-L6B4ALZ3.js");
// src/services/logout.ts
function explicitLogoutFunction(environment, request) {
    var baseUrl = _chunkL6B4ALZ3js.getBaseUrl.call(void 0, environment);
    var state = _chunk7VBK3YDPjs.urlEncodeBase64.call(void 0, _chunk7VBK3YDPjs.encodeState.call(void 0, request));
    return "".concat(baseUrl, "/logout?state=").concat(state);
}
function implicitLogoutFunction(environment, request) {
    return _implicitLogoutFunction.apply(this, arguments);
}
function _implicitLogoutFunction() {
    _implicitLogoutFunction = _async_to_generator(function(environment, request) {
        var baseUrl, implicitLogoutResponse, error, defaultLogoutResponse;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    request.kmsiLogout = false;
                    baseUrl = _chunkL6B4ALZ3js.getApiUrl.call(void 0, environment);
                    return [
                        4,
                        fetch("".concat(baseUrl, "/v1/logout"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(request)
                        })
                    ];
                case 1:
                    implicitLogoutResponse = _state.sent();
                    window.location.replace(request.redirectUri);
                    return [
                        2,
                        implicitLogoutResponse.json()
                    ];
                case 2:
                    error = _state.sent();
                    defaultLogoutResponse = {
                        redirectUri: request.redirectUri,
                        status: {
                            USER_LOGOUT: "UNKNOWN",
                            REVOKE_KMSI: "NOT_EXECUTED",
                            REVOKE_REFRESH_TOKEN: "UNKNOWN"
                        },
                        message: error.toString()
                    };
                    return [
                        2,
                        defaultLogoutResponse
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _implicitLogoutFunction.apply(this, arguments);
}
exports.explicitLogoutFunction = explicitLogoutFunction;
exports.implicitLogoutFunction = implicitLogoutFunction;
